"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSharedListOne = void 0;
const organization_1 = require("./organization");
const utils_1 = require("../utils");
const organization = (0, organization_1.mockChildOrganization)();
const base = Object.assign({ id: 1, organization_id: organization.id, title: 'List One', form_id: null, description: null }, utils_1.mockDateObject);
exports.mockSharedListOne = (0, utils_1.mockFunction)(Object.assign({}, base));
